<template>
  <section class="container mx-auto py-6 md:py-14">
    <h2 class="text-center md:text-left section-heading mb-8">
      Employee Benefits that Prioritize You
    </h2>

    <div class="benefits grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <template v-if="isLoading">
        <div v-for="index in 4" :key="index" class="flex flex-col gap-3">
          <div class="number text-primary-primary">
            <UtilsSkeletonLoading class="w-10 h-7" />
          </div>
          <div class="desc">
            <UtilsSkeletonLoading class="w-full h-10 mb-4" />
            <UtilsSkeletonLoading class="w-full h-20" />
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-for="(benefit, index) in benefits?.attributes?.benefit"
          :key="benefit?.id"
          class="flex flex-col gap-2 md:gap-3"
        >
          <div class="number text-primary-primary">
            <span class="text-base">{{ `0${index + 1}` }}</span>
          </div>
          <div class="desc">
            <h3
              class="text-base md:text-2xl md:leading-normal font-medium mb-3 text-bw-900"
            >
              {{ benefit?.title }}
            </h3>
            <p class="text-base text-bw-900">
              {{ benefit?.description }}
            </p>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const benefits = ref([])

const getBenefits = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/career-benefit`,
    {
      query: {
        populate: 'benefit'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Activities does not exist`
    })
  }

  return data.value
}

const benefitData = await getBenefits()
benefits.value = benefitData.data
</script>

<style lang="scss" scoped></style>
